"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.routeToGtmNameMap = exports.GTM = exports.RR6_ROUTES = exports.LANDING_PAGES = exports.ROUTE_TABLE = exports.BASE_ROUTE_DIAGNOSTIC_LINK = exports.BASE_ROUTE_VT_DASH = exports.BASE_ROUTE = exports.APP_MODE = void 0;
exports.APP_MODE = {
    PORTAL: 'DTPortal',
    VTDASH: 'VTDash',
    DIAGNOSTIC_LINK: 'DiagnosticLink',
};
exports.BASE_ROUTE = "/".concat(exports.APP_MODE.PORTAL);
exports.BASE_ROUTE_VT_DASH = "/".concat(exports.APP_MODE.VTDASH);
exports.BASE_ROUTE_DIAGNOSTIC_LINK = "/".concat(exports.APP_MODE.DIAGNOSTIC_LINK);
exports.ROUTE_TABLE = {
    PORTAL: {
        CHARGING: {
            INDEX: "".concat(exports.BASE_ROUTE, "/charging"),
            DISPENSERS_LIST: "".concat(exports.BASE_ROUTE, "/charging/dispensers"),
            DISPENSERS_DETAILS: {
                GENERAL: "".concat(exports.BASE_ROUTE, "/charging/dispensers/:id/general"),
            },
            DEPOS: "".concat(exports.BASE_ROUTE, "/charging/depos"),
            SESSIONS: "".concat(exports.BASE_ROUTE, "/charging/sessions"),
            TIMERS: "".concat(exports.BASE_ROUTE, "/charging/timers"),
            DASHBOARD: "".concat(exports.BASE_ROUTE, "/charging/dashboard"),
        },
        DIAGNOSIS: "".concat(exports.BASE_ROUTE, "/vehicle-health/diagnosis/:streamingSource/:event"),
        DATA_PRIVACY: "".concat(exports.BASE_ROUTE, "/dataprivacy"),
        FOTA: "".concat(exports.BASE_ROUTE, "/fota"),
        CAMPAIGNS: "".concat(exports.BASE_ROUTE, "/fota/campaigns/:campaignid"),
        INDEX: "".concat(exports.BASE_ROUTE),
        INVITE_DEALER: "".concat(exports.BASE_ROUTE, "/invitedealer"),
        INVITE_DEALER_CONFIRMATION: "".concat(exports.BASE_ROUTE, "/invitedealerconfirmation"),
        FAULTS: {
            INDEX: "".concat(exports.BASE_ROUTE, "/vehicle-health/faults"),
            FLEET_HEALTH: "".concat(exports.BASE_ROUTE, "/faults/fleet-health"),
        },
        ANALYTICS: {
            INDEX: "".concat(exports.BASE_ROUTE, "/analytics"),
            FUEL_ECONOMY: "".concat(exports.BASE_ROUTE, "/analytics/fuel-economy"),
            SAFETY_PERFORMANCE: "".concat(exports.BASE_ROUTE, "/analytics/safety-performance"),
            DRIVE_SCORE: "".concat(exports.BASE_ROUTE, "/analytics/drive-score"),
            FLEET_FUEL_ANALYSIS: "".concat(exports.BASE_ROUTE, "/analytics/fuel-analytics"),
            FLEET_FUEL_ANALYSIS_DETAIL: "".concat(exports.BASE_ROUTE, "/analytics/fuel-analytics/:vin"),
        },
        PARAMETERS: "".concat(exports.BASE_ROUTE, "/parameters"),
        SERVICE_CENTER: "".concat(exports.BASE_ROUTE, "/vehicle-health/service-center/:centerId"),
        VEHICLE_INFO: {
            BASE: "".concat(exports.BASE_ROUTE, "/vehicle/:vin"),
            INDEX: "".concat(exports.BASE_ROUTE, "/vehicle-health/vehicle/:vin/history"),
            SAFETY: {
                INDEX: "".concat(exports.BASE_ROUTE, "/vehicle/:vin/safety"),
                SAFETY_EVENT_DETAILS: "".concat(exports.BASE_ROUTE, "/vehicle/:vin/safety/:timestamp/:safetyDateRange"),
            },
            SAFETY_FEATURES: {
                INDEX: "".concat(exports.BASE_ROUTE, "/vehicle/:vin/safety-features"),
                SAFETY_EVENT_DETAILS: "".concat(exports.BASE_ROUTE, "/vehicle/:vin/safety-features"),
            },
            SAFETY_REDESIGN: {
                INDEX: "".concat(exports.BASE_ROUTE, "/vehicle/:vin/safety-redesign"),
                SAFETY_EVENT_DETAILS: "".concat(exports.BASE_ROUTE, "/vehicle/:vin/safety-redesign/:timestamp"),
            },
            DRIVE_SCORE: "".concat(exports.BASE_ROUTE, "/vehicle/:vin/drive-score"),
            DRIVE_SCORE_DETAILS: "".concat(exports.BASE_ROUTE, "/vehicle/:vin/drive-score/:rowKey"),
            DDEC: {
                INDEX: "".concat(exports.BASE_ROUTE, "/vehicle/:vin/ddec"),
                CABLE_CONNECTED_PREVIEW: "".concat(exports.BASE_ROUTE, "/vehicle/:vin/ddec/cc/preview/:rowKey"),
                OVER_THE_AIR_PREVIEW: "".concat(exports.BASE_ROUTE, "/vehicle/:vin/ddec/oth/preview/:operationId"),
            },
            ETRIPS: {
                INDEX: "".concat(exports.BASE_ROUTE, "/vehicle-health/vehicle/:vin/etrips"),
            },
            TRIPS: {
                INDEX: "".concat(exports.BASE_ROUTE, "/vehicle/:vin/trips"),
                TRIP_REPORT: "".concat(exports.BASE_ROUTE, "/vehicle/:vin/trips/:rowKey"),
            },
            TRACK_AND_TRACE: "".concat(exports.BASE_ROUTE, "/vehicle/:vin/track-and-trace"),
            LOCK_UNLOCK: "".concat(exports.BASE_ROUTE, "/vehicle/:vin/lock-unlock"),
        },
        VT_EMAIL_DOESNT_EXIST: "".concat(exports.BASE_ROUTE, "/email-required"),
        VT_EMAIL_SENT: "".concat(exports.BASE_ROUTE, "/email-sent"),
        MAINTENANCE_SYSTEM: "".concat(exports.BASE_ROUTE, "/maintenance-system"),
        GEOFENCING: "".concat(exports.BASE_ROUTE, "/geofencing"),
    },
    DIAGNOSTIC_LINK: {
        SIGN_IN: "".concat(exports.BASE_ROUTE_DIAGNOSTIC_LINK, "/signin"),
    },
    LOGIN: "".concat(exports.BASE_ROUTE, "/login"),
    PARAMETERS: "".concat(exports.BASE_ROUTE, "/parameters"),
    ROOT: "".concat(exports.BASE_ROUTE, "/"),
    SIGNUP: {
        ACCOUNT_ACTIVATED: "".concat(exports.BASE_ROUTE, "/signup/accountactivated"),
        BROWSER_NOT_SUPPORTED: "".concat(exports.BASE_ROUTE, "/signup/browsernotsupported"),
        CONFIRM: "".concat(exports.BASE_ROUTE, "/signup/confirm"),
        CREATE_PASSWORD: "".concat(exports.BASE_ROUTE, "/signup/createpassword/:token"),
        LINK_NOT_AVAILABLE: "".concat(exports.BASE_ROUTE, "/signup/linknotavailable"),
        REGISTER: "".concat(exports.BASE_ROUTE, "/signup"),
        REGISTER_CAN: "".concat(exports.BASE_ROUTE, "/signup/can"),
        SERVER_ERROR: "".concat(exports.BASE_ROUTE, "/signup/error"),
        SUPPORT_TICKET: "".concat(exports.BASE_ROUTE, "/signup/supportticket"),
        TERMS_REJECTED: "".concat(exports.BASE_ROUTE, "/signup/termsrejected"),
        TOKEN_EXPIRED: "".concat(exports.BASE_ROUTE, "/signup/tokenexpired"),
    },
    SIGNUP_REQUEST: "".concat(exports.BASE_ROUTE, "/signuprequest/token/:token"),
    TERMS: "".concat(exports.BASE_ROUTE, "/terms"),
    VERIFY: "".concat(exports.BASE_ROUTE, "/verify"),
    VERIFY_TOKEN: "".concat(exports.BASE_ROUTE, "/verifytoken"),
    HELP_AND_SUPPORT: {
        BASE: "".concat(exports.BASE_ROUTE, "/help"),
        FAQ: "".concat(exports.BASE_ROUTE, "/help/faq"),
        GUIDES_AND_TUTORIALS: "".concat(exports.BASE_ROUTE, "/help/guides-and-tutorials"),
        CONTACT_INFORMATION: "".concat(exports.BASE_ROUTE, "/help/contact"),
        TERMS_AND_CONDITIONS: "".concat(exports.BASE_ROUTE, "/help/termsandconditions"),
        PRIVACY_POLICY: "".concat(exports.BASE_ROUTE, "/help/privacy-policy"),
        LICENSES: "".concat(exports.BASE_ROUTE, "/help/licenses"),
    },
    SETTINGS: {
        BASE_ROUTE: "".concat(exports.BASE_ROUTE, "/settings"),
        ADMIN_MANAGE: "".concat(exports.BASE_ROUTE, "/settings/admin/manage"),
        ADMIN_PROFILE_EDIT: "".concat(exports.BASE_ROUTE, "/settings/admin/manage/users/:user/edit"),
        CUSTOM_TAGS: "".concat(exports.BASE_ROUTE, "/settings/admin/vehicles/customtags"),
        UNIT_ID: "".concat(exports.BASE_ROUTE, "/settings/admin/vehicles/unitid"),
        FLEET: {
            ANALYTICS: "".concat(exports.BASE_ROUTE, "/settings/admin/analytics-settings"),
            GLOBAL: "".concat(exports.BASE_ROUTE, "/settings/admin/global"),
            NOTIFICATIONS: {
                FAULT_SETTINGS: {
                    INDEX: "".concat(exports.BASE_ROUTE, "/settings/admin/notifications/faults"),
                    INDIVIDUAL: "".concat(exports.BASE_ROUTE, "/settings/admin/notifications/faults/individual"),
                    SN: "".concat(exports.BASE_ROUTE, "/settings/admin/notifications/faults/SN"),
                    SS: "".concat(exports.BASE_ROUTE, "/settings/admin/notifications/faults/SS"),
                    SP: "".concat(exports.BASE_ROUTE, "/settings/admin/notifications/faults/SP"),
                    SI: "".concat(exports.BASE_ROUTE, "/settings/admin/notifications/faults/SI"),
                },
                INDEX: "".concat(exports.BASE_ROUTE, "/settings/admin/notifications"),
                SAFETY_EVENTS: {
                    COLLISION_MITIGATION_BRAKING: "".concat(exports.BASE_ROUTE, "/settings/admin/notifications/safetyevents/collisionmitigationbraking"),
                    ENHANCED_STABILITY_CONTROL_EVENT: "".concat(exports.BASE_ROUTE, "/settings/admin/notifications/safetyevents/enhancedstabilitycontrol"),
                    FORWARD_COLLISION_WARNING: "".concat(exports.BASE_ROUTE, "/settings/admin/notifications/safetyevents/forwardcollisionwarning"),
                    HANDS_OFF_WHEEL: "".concat(exports.BASE_ROUTE, "/settings/admin/notifications/safetyevents/handsoffwheel"),
                    ACTIVE_SIDE_GUARD_ASSIST_BRAKING: "".concat(exports.BASE_ROUTE, "/settings/admin/notifications/safetyevents/activesideguardassistbraking"),
                    INDEX: "".concat(exports.BASE_ROUTE, "/settings/admin/notifications/safetyevents"),
                    ROLL_STABILITY_CONTROL_EVENT: "".concat(exports.BASE_ROUTE, "/settings/admin/notifications/safetyevents/rollstabilitycontrol"),
                    SEVERE_BRAKING: "".concat(exports.BASE_ROUTE, "/settings/admin/notifications/safetyevents/severebraking"),
                },
                SAFETY_SYSTEMS: {
                    INDEX: "".concat(exports.BASE_ROUTE, "/settings/admin/notifications/safetysystems"),
                    ABA: "".concat(exports.BASE_ROUTE, "/settings/admin/notifications/aba"),
                },
                SETTINGS: "".concat(exports.BASE_ROUTE, "/settings/admin/notifications/settings"),
            },
            REGISTRATION: "".concat(exports.BASE_ROUTE, "/settings/admin/registration"),
        },
        REGISTRATION: "".concat(exports.BASE_ROUTE, "/settings/admin/registration"),
        ROLE_CREATE: "".concat(exports.BASE_ROUTE, "/settings/admin/manage/create/role"),
        ROLE_EDIT: "".concat(exports.BASE_ROUTE, "/settings/admin/manage/roles/:role/edit"),
        USER_PROFILE: "".concat(exports.BASE_ROUTE, "/settings/admin/user/:user/profile"),
        MANAGE_VEHICLES: {
            VEHICLE_CONTACTS: "".concat(exports.BASE_ROUTE, "/settings/admin/vehicles/contacts"),
            NEW_VEHICLE_CONTACT: "".concat(exports.BASE_ROUTE, "/settings/admin/vehicles/contacts/new"),
            EDIT_VEHICLE_CONTACT: "".concat(exports.BASE_ROUTE, "/settings/admin/vehicles/contacts/edit/:email"),
            UNIT_ID: "".concat(exports.BASE_ROUTE, "/settings/admin/vehicles/unitid"),
        },
    },
    VTDASH: {
        ASSET_MANAGER: "".concat(exports.BASE_ROUTE_VT_DASH, "/assets"),
        EVENT_DIAGNOSIS: "".concat(exports.BASE_ROUTE_VT_DASH, "/vehicle-health/diagnosis/:event"),
        FAULT_CODE_MANAGER: "".concat(exports.BASE_ROUTE_VT_DASH, "/faultCodes"),
        FINDER: {
            INDEX: "".concat(exports.BASE_ROUTE_VT_DASH, "/vehicle-health/virtual-technician/finder"),
            VEHICLE: "".concat(exports.BASE_ROUTE_VT_DASH, "/vehicle-health/virtual-technician/finder/vehicle"),
            EVENT: "".concat(exports.BASE_ROUTE_VT_DASH, "/vehicle-health/virtual-technician/finder/event"),
        },
        INDEX: "".concat(exports.BASE_ROUTE_VT_DASH, "/vehicle-health/virtual-technician"),
        SERVICE_CENTER: "".concat(exports.BASE_ROUTE_VT_DASH, "/vehicle-health/service-center/:centerId"),
        VEHICLE_INFO: {
            INDEX: "".concat(exports.BASE_ROUTE_VT_DASH, "/vehicle-health/vehicle/:vin/history"),
        },
        REGISTRATION: "".concat(exports.BASE_ROUTE_VT_DASH, "/signuprequest/token"),
        REGISTRATION_SUCCESS: "".concat(exports.BASE_ROUTE_VT_DASH, "/signup-success"),
        REGISTRATION_FAILURE: "".concat(exports.BASE_ROUTE_VT_DASH, "/signup-failure"),
    },
    CHARGING: {
        INDEX: "".concat(exports.BASE_ROUTE, "/chargers"),
        DEPOS: "".concat(exports.BASE_ROUTE, "/depos"),
        TIMELINE: "".concat(exports.BASE_ROUTE, "/timeline"),
        TIMERS: "".concat(exports.BASE_ROUTE, "/timers"),
        DASHBOARD: "".concat(exports.BASE_ROUTE, "/dashboard"),
    },
};
exports.LANDING_PAGES = {
    PORTAL: exports.ROUTE_TABLE.PORTAL.INDEX,
    VTDASH: exports.ROUTE_TABLE.VTDASH.FINDER.INDEX,
};
exports.default = exports.ROUTE_TABLE;
/**
 * This structure is necesary due to RR6 not having suport for absolute paths
 * so this routes table is only used as path descriptor and it follows the
 * composition patterns present on relative paths. Whenever the route display
 * a new router, the path for that route should end in a * to catch all the decendants
 * and still matching.
 */
exports.RR6_ROUTES = {
    PORTAL: {
        CHARGING: {
            INDEX: 'charging/*',
            DISPENSERS_LIST: 'dispensers',
            DISPENSERS_DETAILS: {
                GENERAL: 'dispensers/:id/general',
            },
            DEPOS: 'charging/depos',
            SESSIONS: 'sessions',
            TIMERS: 'charging/timers',
            DASHBOARD: 'charging/dashboard',
        },
        DIAGNOSIS: 'vehicle-health/diagnosis/:streamingSource/:event',
        DATA_PRIVACY: 'dataprivacy',
        FOTA: 'fota',
        CAMPAIGNS: 'fota/campaigns/:campaignid',
        INDEX: "".concat(exports.BASE_ROUTE, "/*"),
        INVITE_DEALER: 'invitedealer',
        INVITE_DEALER_CONFIRMATION: 'invitedealerconfirmation',
        FAULTS: {
            INDEX: 'vehicle-health/faults/*',
            FLEET_HEALTH: 'fleet-health',
        },
        ANALYTICS: {
            INDEX: 'analytics/*',
            FUEL_ECONOMY: 'fuel-economy',
            SAFETY_PERFORMANCE: 'safety-performance',
            DRIVE_SCORE: 'drive-score',
            FLEET_FUEL_ANALYSIS: 'fuel-analytics',
            FLEET_FUEL_ANALYSIS_DETAIL: 'fuel-analytics/:vin',
        },
        PARAMETERS: 'parameters',
        SERVICE_CENTER: 'vehicle-health/service-center/:centerId',
        VEHICLE_INFO: {
            BASE: '/vehicle/:vin/*',
            INDEX: 'history',
            SAFETY: {
                INDEX: 'safety',
                SAFETY_EVENT_DETAILS: 'safety/:timestamp/:safetyDateRange',
            },
            SAFETY_FEATURES: {
                INDEX: 'safety-features',
                SAFETY_EVENT_DETAILS: 'safety-features',
            },
            SAFETY_REDESIGN: {
                INDEX: 'safety-redesign',
                SAFETY_EVENT_DETAILS: 'safety-redesign/:timestamp',
            },
            DRIVE_SCORE: 'drive-score',
            DRIVE_SCORE_DETAILS: 'drive-score/:rowKey',
            DDEC: {
                INDEX: 'ddec',
                CABLE_CONNECTED_PREVIEW: 'ddec/cc/preview/:rowKey',
                OVER_THE_AIR_PREVIEW: 'ddec/oth/preview/:operationId',
            },
            ETRIPS: {
                INDEX: 'etrips',
            },
            TRIPS: {
                INDEX: 'trips',
                TRIP_REPORT: 'trips/:rowKey',
            },
            TRACK_AND_TRACE: 'track-and-trace',
            LOCK_UNLOCK: 'lock-unlock',
        },
        VT_EMAIL_DOESNT_EXIST: '/email-required',
        VT_EMAIL_SENT: '/email-sent',
        MAINTENANCE_SYSTEM: 'maintenance-system',
        GEOFENCING: 'geofencing',
    },
    DIAGNOSTIC_LINK: {
        SIGN_IN: "".concat(exports.BASE_ROUTE_DIAGNOSTIC_LINK, "/signin"),
    },
    LOGIN: '/login',
    PARAMETERS: '/parameters',
    ROOT: '/',
    SIGNUP: {
        ACCOUNT_ACTIVATED: 'accountactivated',
        BROWSER_NOT_SUPPORTED: 'browsernotsupported',
        CONFIRM: 'confirm',
        CREATE_PASSWORD: 'createpassword/:token',
        LINK_NOT_AVAILABLE: 'linknotavailable',
        REGISTER: 'signup/*',
        REGISTER_CAN: 'can',
        SERVER_ERROR: 'error',
        SUPPORT_TICKET: 'supportticket',
        TERMS_REJECTED: 'termsrejected',
        TOKEN_EXPIRED: 'tokenexpired',
    },
    SIGNUP_REQUEST: '/signuprequest/token/:token',
    TERMS: '/terms',
    VERIFY: '/verify',
    VERIFY_TOKEN: '/verifytoken',
    HELP_AND_SUPPORT: {
        BASE: 'help/*',
        FAQ: 'faq',
        GUIDES_AND_TUTORIALS: 'guides-and-tutorials',
        CONTACT_INFORMATION: 'contact',
        TERMS_AND_CONDITIONS: 'termsandconditions',
        PRIVACY_POLICY: 'privacy-policy',
        LICENSES: 'licenses',
    },
    SETTINGS: {
        BASE_ROUTE: 'settings/*',
        ADMIN_MANAGE: 'admin/manage',
        ADMIN_PROFILE_EDIT: 'admin/manage/users/:user/edit',
        CUSTOM_TAGS: 'admin/vehicles/customtags',
        UNIT_ID: 'admin/vehicles/unitid',
        FLEET: {
            ANALYTICS: 'admin/analytics-settings',
            GLOBAL: 'admin/global/*',
            NOTIFICATIONS: {
                FAULT_SETTINGS: {
                    INDEX: 'faults/*',
                    INDIVIDUAL: 'faults/individual',
                    SN: 'faults/SN',
                    SS: 'faults/SS',
                    SP: 'faults/SP',
                    SI: 'faults/SI',
                },
                INDEX: 'admin/notifications/*',
                SAFETY_EVENTS: {
                    COLLISION_MITIGATION_BRAKING: 'safetyevents/collisionmitigationbraking',
                    ENHANCED_STABILITY_CONTROL_EVENT: 'safetyevents/enhancedstabilitycontrol',
                    FORWARD_COLLISION_WARNING: 'safetyevents/forwardcollisionwarning',
                    HANDS_OFF_WHEEL: 'safetyevents/handsoffwheel',
                    ACTIVE_SIDE_GUARD_ASSIST_BRAKING: 'safetyevents/activesideguardassistbraking',
                    INDEX: 'safetyevents/*',
                    ROLL_STABILITY_CONTROL_EVENT: 'safetyevents/rollstabilitycontrol',
                    SEVERE_BRAKING: 'safetyevents/severebraking',
                },
                SAFETY_SYSTEMS: {
                    INDEX: 'safetysystems',
                    ABA: 'aba',
                },
                SETTINGS: 'settings',
            },
            REGISTRATION: 'admin/registration',
        },
        REGISTRATION: 'admin/registration',
        ROLE_CREATE: 'admin/manage/create/role',
        ROLE_EDIT: 'admin/manage/roles/:role/edit',
        USER_PROFILE: 'admin/user/:user/profile',
        MANAGE_VEHICLES: {
            VEHICLE_CONTACTS: 'admin/vehicles/contacts/*',
            NEW_VEHICLE_CONTACT: 'new',
            EDIT_VEHICLE_CONTACT: 'edit/:email',
            UNIT_ID: 'admin/vehicles/unitid',
        },
    },
    VTDASH: {
        ASSET_MANAGER: '',
        EVENT_DIAGNOSIS: 'vehicle-health/diagnosis/:event',
        FAULT_CODE_MANAGER: 'faultCodes',
        FINDER: {
            INDEX: 'finder',
            VEHICLE: 'finder/vehicle',
            EVENT: 'finder/event',
        },
        INDEX: "".concat(exports.BASE_ROUTE_VT_DASH, "/*"),
        SERVICE_CENTER: 'vehicle-health/service-center/:centerId',
        VEHICLE_INFO: {
            INDEX: 'vehicle-health/vehicle/:vin/history',
        },
        REGISTRATION: 'signuprequest/token',
        REGISTRATION_SUCCESS: 'signup-success',
        REGISTRATION_FAILURE: 'signup-failure',
    },
    CHARGING: {
        INDEX: '/chargers',
        DEPOS: '/depos',
        TIMELINE: '/timeline',
        TIMERS: '/timers',
        DASHBOARD: '/dashboard',
    },
};
exports.GTM = {
    ACTIONS: {
        VEHICLE_LIST: 'vehicle list',
    },
    CATEGORIES: {
        VEHICLE_LIST: 'vehicle list',
    },
    EVENTS: {
        CLICK: 'click',
        PAGE_LOAD: 'pageload',
    },
    PROPS: {
        PAGE_NAME: 'page_name',
        FLEET_NAME: 'fleet_name',
        USER_TYPE: 'user_type',
        EVENT: 'event',
        GA_CATEGORY: 'ga_category',
        GA_ACTION: 'ga_action',
    },
    USER_TYPES: {
        DTNA_SUPERUSER: 'dtna superuser',
        DTNA_SUPERADMIN: 'dtna superadmin',
        FLEET_ADMIN: 'fleet admin',
        FLEET_USER: 'fleet user',
    },
    PAGE_NAME: {
        CHARGING: {
            DISPENSERS_LIST: 'Charging: Dispensers List',
            DISPENSERS_DETAILS: 'Charging: Dispenser Details',
            DEPOS: 'Charging: Depos',
            TIMELINE: 'Charging: Timeline',
            TIMERS: 'Charging: Timers',
            DASHBOARD: 'Charging: Dashboard',
        },
        ANALYTICS: {
            INDEX: 'Analytics: Fuel Economy',
            FUEL_ECONOMY: 'Analytics: Fuel Economy',
            FLEET_FUEL_ANALYTICS: 'Analytics: Fleet Fuel',
            SAFETY_PERFORMANCE: 'Analytics: Safety Performance',
            DRIVE_SCORE: 'Analytics: Drive Score',
            SAFETY_FEATURES: 'Analytics: Safety Features',
        },
        DATA_PRIVACY: 'Data Privacy',
        INVITE_DEALER: 'Invite a Fleet Administrator',
        INVITE_DEALER_CONFIRMATION: 'Invitation Sent',
        VEHICLE_LIST: 'Vehicle List',
        VEHICLE_INFO: 'Vehicle Info: History',
        SAFETY_EVENT_DETAIL: 'Safety Event Details',
        SAFETY_FEATURES: 'Safety Features',
        LOGIN: 'Login',
        POTA: 'Parameter Profiles',
        FOTA: 'Firmware Updates',
        EVENT_DIAGNOSIS: 'Event Diagnosis',
        FAULTS: {
            INDEX: 'Faults: Fault Event Inbox',
            FLEET_HEALTH: 'Faults: Fleet Health',
        },
        FLEET_GLOBAL_SETTINGS: 'Fleet Global Settings',
        HELP_AND_SUPPORT: {
            BASE: 'Help and Support base page',
            FAQ: 'Help and Support FAQ',
            GUIDES_AND_TUTORIALS: 'Help and Support Guides & Tutorials',
            CONTACT_INFORMATION: 'Help and Support Contact Information',
            TERMS_AND_CONDITIONS: 'Help and Support Terms and Conditions',
            PRIVACY_POLICY: 'Help and Support Privacy Policy',
            LICENSES: 'Help and Support Open Source Lincenses',
        },
        MANAGE_CUSTOM_TAGS: 'Manage Vehicle Custom Tags',
        MANAGE_UNIT_ID: 'Manage Vehicle Unit ID',
        MANAGE_USERS_AND_ROLES: 'Manage Users and Roles',
        ROLE_CREATE: 'Create Role',
        ROLE_EDIT: 'Edit Role',
        USER_PROFILE_SETTINGS: 'User Profile Settings',
        VTDASH: {
            EMAIL_SENT: 'VT Registration: Email sent',
            EMAIL_REQUIRED: 'VT Registration: Email Required',
            REGISRTATION_FAILURE: 'VT Registration: Token failure',
            REGISTRATION_SUCCESS: 'VT Registration: Success',
            ASSET_MANAGER: 'VT Dash: Asset Manager',
            FAULT_CODE_MANAGER: 'VT Dash: Fault Code Manager',
            FINDER: {
                INDEX: 'VT Dash: Finder',
                EVENT: 'VT Dash: Event Finder',
                VEHICLE: 'VT Dash: Vehicle Finder',
            },
        },
        SERVICE_CENTER: 'Service Center Details',
        SETTINGS: {
            PROFILE_INFORMATION: 'Settings: Profile Information',
            INDEX: 'Settings: Manage Users & Roles',
            FLEET: {
                ANALYTICS: 'Settings: Analytics',
                GLOBAL: 'Settings: Global',
                REGISTRATION: 'Settings: Registration',
                NOTIFICATIONS: {
                    INDEX: 'Settings: Notifications',
                    FAULTS: {
                        INDEX: 'Notifications: Fault Notifications Index',
                        INDIVIDUAL: 'Notifications: Fault Notifications: Individual',
                        SS: 'Notifications: Fault Notifications: SS',
                        SN: 'Notifications: Fault Notifications: SN',
                        SP: 'Notifications: Fault Notifications: SP',
                        SI: 'Notifications: Fault Notifications: SI',
                    },
                    SAFETY_EVENTS: {
                        ACTIVE_SIDE_GUARD_ASSIST_BRAKING: 'Notifications: Safety Events: Active Side Guard Assist Braking',
                        COLLISION_MITIGATION_BRAKING: 'Notifications: Safety Events: Collision Mitigation Braking',
                        ENHANCED_STABILITY_CONTROL: 'Notifications: Safety Events: Enhanced Stability Control',
                        FORWARD_COLLISION_WARNING: 'Notifications: Safety Events: Forward Collision Warning',
                        HANDS_OFF_WHEEL: 'Notifications: Safety Events: Hands Off Wheel',
                        INDEX: 'Notifications: Safety Events Index',
                        ROLL_STABILITY_CONTROL: 'Notifications: Safety Events: Roll Stability Control',
                        SEVERE_BRAKING: 'Notifications: Safety Events: Severe Braking',
                    },
                    SAFETY_SYSTEMS: {
                        LIST: 'Safety Systems List',
                        ABA: 'ACTIVE BRAKE ASSIST',
                    },
                    SETTINGS: 'Notifications: Settings',
                },
                NOTIFICATIONS_INDIVIDUAL_FAULTS: 'Settings: Individual Notification Settings',
            },
            REGISTRATION: 'Settings Fleet Registration',
            USERS: {
                ROLE_CREATE: 'Settings: Create Role',
                ROLE_EDIT: 'Settings: Edit Role',
            },
            VEHICLES: {
                CUSTOM_TAGS: 'Settings: Custom Tags',
                VEHICLE_CONTACTS: 'Settings: Vehicle Contacts',
                NEW_VEHICLE_CONTACT: 'Settings: New Vehicle Contact',
                EDIT_VEHICLE_CONTACT: 'Settings: Edit Vehicle Contact',
                UNIT_ID: 'Settings: Unit ID',
            },
        },
        SIGN_UP: {
            ACCOUNT_ACTIVATED: 'Account Activated',
            BROWSER_NOT_SUPPORTED: 'Browser Not Supported',
            CONFIRM: 'Confirm Your Identity',
            CREATE_PASSWORD: 'Create Your Password',
            LINK_NOT_AVAILABLE: 'Link was already used',
            REGISTER: 'Sign up index',
            REGISTER_CAN: 'Sign up - can',
            SERVER_ERROR: 'Error',
            SUPPORT_TICKET: 'Support Ticket',
            TERMS_REJECTED: 'Terms Rejected',
            TOKEN_EXPIRED: 'Token Expired',
        },
        TERMS: 'Terms and Conditions',
        MAINTENANCE_SYSTEM: 'Maintenance System',
        GEOFENCING: 'Geofencing',
    },
};
exports.routeToGtmNameMap = new Map(Object.entries((_a = {},
    _a[exports.ROUTE_TABLE.PORTAL.FAULTS.INDEX] = exports.GTM.PAGE_NAME.FAULTS.INDEX,
    _a[exports.ROUTE_TABLE.PORTAL.FAULTS.FLEET_HEALTH] = exports.GTM.PAGE_NAME.FAULTS.FLEET_HEALTH,
    _a[exports.ROUTE_TABLE.PORTAL.CHARGING.DASHBOARD] = exports.GTM.PAGE_NAME.CHARGING.DASHBOARD,
    _a[exports.ROUTE_TABLE.PORTAL.CHARGING.DEPOS] = exports.GTM.PAGE_NAME.CHARGING.DEPOS,
    //  [ROUTE_TABLE.PORTAL.CHARGING.DISPENSERS_DETAILS]: GTM.PAGE_NAME.CHARGING.DISPENSERS_DETAILS,
    _a[exports.ROUTE_TABLE.PORTAL.CHARGING.DISPENSERS_LIST] = exports.GTM.PAGE_NAME.CHARGING.DISPENSERS_LIST,
    //  [ROUTE_TABLE.PORTAL.CHARGING.TIMELINE]: GTM.PAGE_NAME.CHARGING.TIMELINE,
    _a[exports.ROUTE_TABLE.PORTAL.CHARGING.TIMERS] = exports.GTM.PAGE_NAME.CHARGING.TIMERS,
    _a[exports.ROUTE_TABLE.PORTAL.ANALYTICS.INDEX] = exports.GTM.PAGE_NAME.ANALYTICS.INDEX,
    _a[exports.ROUTE_TABLE.PORTAL.ANALYTICS.DRIVE_SCORE] = exports.GTM.PAGE_NAME.ANALYTICS.DRIVE_SCORE,
    _a[exports.ROUTE_TABLE.PORTAL.ANALYTICS.FUEL_ECONOMY] = exports.GTM.PAGE_NAME.ANALYTICS.FUEL_ECONOMY,
    _a[exports.ROUTE_TABLE.PORTAL.ANALYTICS.SAFETY_PERFORMANCE] = exports.GTM.PAGE_NAME.ANALYTICS.SAFETY_PERFORMANCE,
    _a[exports.ROUTE_TABLE.PORTAL.ANALYTICS.FLEET_FUEL_ANALYSIS] = exports.GTM.PAGE_NAME.ANALYTICS.FLEET_FUEL_ANALYTICS,
    _a[exports.ROUTE_TABLE.PORTAL.ANALYTICS.FLEET_FUEL_ANALYSIS_DETAIL] = exports.GTM.PAGE_NAME.ANALYTICS.FLEET_FUEL_ANALYTICS,
    _a[exports.ROUTE_TABLE.HELP_AND_SUPPORT.BASE] = exports.GTM.PAGE_NAME.HELP_AND_SUPPORT.BASE,
    _a[exports.ROUTE_TABLE.HELP_AND_SUPPORT.CONTACT_INFORMATION] = exports.GTM.PAGE_NAME.HELP_AND_SUPPORT.CONTACT_INFORMATION,
    _a[exports.ROUTE_TABLE.HELP_AND_SUPPORT.FAQ] = exports.GTM.PAGE_NAME.HELP_AND_SUPPORT.FAQ,
    _a[exports.ROUTE_TABLE.HELP_AND_SUPPORT.GUIDES_AND_TUTORIALS] = exports.GTM.PAGE_NAME.HELP_AND_SUPPORT.GUIDES_AND_TUTORIALS,
    _a[exports.ROUTE_TABLE.HELP_AND_SUPPORT.LICENSES] = exports.GTM.PAGE_NAME.HELP_AND_SUPPORT.LICENSES,
    _a[exports.ROUTE_TABLE.HELP_AND_SUPPORT.PRIVACY_POLICY] = exports.GTM.PAGE_NAME.HELP_AND_SUPPORT.PRIVACY_POLICY,
    _a[exports.ROUTE_TABLE.HELP_AND_SUPPORT.TERMS_AND_CONDITIONS] = exports.GTM.PAGE_NAME.HELP_AND_SUPPORT.TERMS_AND_CONDITIONS,
    _a[exports.ROUTE_TABLE.VTDASH.ASSET_MANAGER] = exports.GTM.PAGE_NAME.VTDASH.ASSET_MANAGER,
    //  [ROUTE_TABLE.VTDASH.EMAIL_REQUIRED]: GTM.PAGE_NAME.VTDASH.EMAIL_REQUIRED,
    //  [ROUTE_TABLE.VTDASH.EMAIL_SENT]: GTM.PAGE_NAME.VTDASH.EMAIL_SENT,
    _a[exports.ROUTE_TABLE.VTDASH.FAULT_CODE_MANAGER] = exports.GTM.PAGE_NAME.VTDASH.FAULT_CODE_MANAGER,
    _a[exports.ROUTE_TABLE.VTDASH.FINDER.INDEX] = exports.GTM.PAGE_NAME.VTDASH.FINDER,
    _a[exports.ROUTE_TABLE.VTDASH.REGISTRATION_FAILURE] = exports.GTM.PAGE_NAME.VTDASH.REGISRTATION_FAILURE,
    _a[exports.ROUTE_TABLE.VTDASH.REGISTRATION_SUCCESS] = exports.GTM.PAGE_NAME.VTDASH.REGISTRATION_SUCCESS,
    _a[exports.ROUTE_TABLE.VTDASH.EVENT_DIAGNOSIS] = exports.GTM.PAGE_NAME.EVENT_DIAGNOSIS,
    _a[exports.ROUTE_TABLE.VTDASH.VEHICLE_INFO.INDEX] = exports.GTM.PAGE_NAME.VEHICLE_INFO,
    _a[exports.ROUTE_TABLE.PORTAL.DATA_PRIVACY] = exports.GTM.PAGE_NAME.DATA_PRIVACY,
    _a[exports.ROUTE_TABLE.PORTAL.INVITE_DEALER] = exports.GTM.PAGE_NAME.INVITE_DEALER,
    _a[exports.ROUTE_TABLE.PORTAL.INVITE_DEALER_CONFIRMATION] = exports.GTM.PAGE_NAME.INVITE_DEALER_CONFIRMATION,
    _a[exports.ROUTE_TABLE.PORTAL.INDEX] = exports.GTM.PAGE_NAME.VEHICLE_LIST,
    _a[exports.ROUTE_TABLE.PORTAL.VEHICLE_INFO.BASE] = exports.GTM.PAGE_NAME.VEHICLE_INFO,
    _a[exports.ROUTE_TABLE.PORTAL.VEHICLE_INFO.SAFETY.INDEX] = exports.GTM.PAGE_NAME.SAFETY_EVENT_DETAIL,
    _a[exports.ROUTE_TABLE.LOGIN] = exports.GTM.PAGE_NAME.LOGIN,
    _a[exports.ROUTE_TABLE.PORTAL.PARAMETERS] = exports.GTM.PAGE_NAME.POTA,
    _a[exports.ROUTE_TABLE.PORTAL.FOTA] = exports.GTM.PAGE_NAME.FOTA,
    _a[exports.ROUTE_TABLE.PORTAL.DIAGNOSIS] = exports.GTM.PAGE_NAME.EVENT_DIAGNOSIS,
    _a[exports.ROUTE_TABLE.PORTAL.SERVICE_CENTER] = exports.GTM.PAGE_NAME.SERVICE_CENTER,
    // [ROUTE_TABLE.PORTAL.TERMS]: GTM.PAGE_NAME.TERMS,
    _a[exports.ROUTE_TABLE.PORTAL.MAINTENANCE_SYSTEM] = exports.GTM.PAGE_NAME.MAINTENANCE_SYSTEM,
    _a[exports.ROUTE_TABLE.PORTAL.GEOFENCING] = exports.GTM.PAGE_NAME.GEOFENCING,
    _a[exports.ROUTE_TABLE.SETTINGS.ROLE_EDIT] = exports.GTM.PAGE_NAME.ROLE_EDIT,
    _a[exports.ROUTE_TABLE.SETTINGS.USER_PROFILE] = exports.GTM.PAGE_NAME.USER_PROFILE_SETTINGS,
    _a[exports.ROUTE_TABLE.SETTINGS.ADMIN_MANAGE] = exports.GTM.PAGE_NAME.MANAGE_USERS_AND_ROLES,
    _a[exports.ROUTE_TABLE.SETTINGS.FLEET.GLOBAL] = exports.GTM.PAGE_NAME.FLEET_GLOBAL_SETTINGS,
    _a[exports.ROUTE_TABLE.SETTINGS.CUSTOM_TAGS] = exports.GTM.PAGE_NAME.MANAGE_CUSTOM_TAGS,
    _a[exports.ROUTE_TABLE.SETTINGS.MANAGE_VEHICLES.VEHICLE_CONTACTS] = exports.GTM.PAGE_NAME.MANAGE_CUSTOM_TAGS,
    _a[exports.ROUTE_TABLE.SETTINGS.UNIT_ID] = exports.GTM.PAGE_NAME.MANAGE_UNIT_ID,
    _a[exports.ROUTE_TABLE.SETTINGS.USER_PROFILE] = exports.GTM.PAGE_NAME.SETTINGS.PROFILE_INFORMATION,
    _a[exports.ROUTE_TABLE.SETTINGS.BASE_ROUTE] = exports.GTM.PAGE_NAME.SETTINGS.INDEX,
    _a[exports.ROUTE_TABLE.SETTINGS.FLEET.ANALYTICS] = exports.GTM.PAGE_NAME.SETTINGS.FLEET.ANALYTICS,
    _a[exports.ROUTE_TABLE.SETTINGS.FLEET.GLOBAL] = exports.GTM.PAGE_NAME.SETTINGS.FLEET.GLOBAL,
    _a[exports.ROUTE_TABLE.SETTINGS.FLEET.REGISTRATION] = exports.GTM.PAGE_NAME.SETTINGS.FLEET.REGISTRATION,
    _a[exports.ROUTE_TABLE.SETTINGS.FLEET.NOTIFICATIONS.INDEX] = exports.GTM.PAGE_NAME.SETTINGS.FLEET.NOTIFICATIONS.INDEX,
    _a[exports.ROUTE_TABLE.SETTINGS.FLEET.NOTIFICATIONS.FAULT_SETTINGS.INDEX] = exports.GTM.PAGE_NAME.SETTINGS.FLEET.NOTIFICATIONS.FAULTS.INDEX,
    _a[exports.ROUTE_TABLE.SETTINGS.FLEET.NOTIFICATIONS.FAULT_SETTINGS.INDIVIDUAL] = exports.GTM.PAGE_NAME.SETTINGS.FLEET.NOTIFICATIONS.FAULTS.INDIVIDUAL,
    _a[exports.ROUTE_TABLE.SETTINGS.FLEET.NOTIFICATIONS.FAULT_SETTINGS.SS] = exports.GTM.PAGE_NAME.SETTINGS.FLEET.NOTIFICATIONS.FAULTS.SS,
    _a[exports.ROUTE_TABLE.SETTINGS.FLEET.NOTIFICATIONS.FAULT_SETTINGS.SN] = exports.GTM.PAGE_NAME.SETTINGS.FLEET.NOTIFICATIONS.FAULTS.SN,
    _a[exports.ROUTE_TABLE.SETTINGS.FLEET.NOTIFICATIONS.FAULT_SETTINGS.SP] = exports.GTM.PAGE_NAME.SETTINGS.FLEET.NOTIFICATIONS.FAULTS.SP,
    _a[exports.ROUTE_TABLE.SETTINGS.FLEET.NOTIFICATIONS.FAULT_SETTINGS.SI] = exports.GTM.PAGE_NAME.SETTINGS.FLEET.NOTIFICATIONS.FAULTS.SI,
    _a[exports.ROUTE_TABLE.SETTINGS.FLEET.NOTIFICATIONS.SAFETY_EVENTS.ACTIVE_SIDE_GUARD_ASSIST_BRAKING] = exports.GTM.PAGE_NAME.SETTINGS.FLEET.NOTIFICATIONS.SAFETY_EVENTS.ACTIVE_SIDE_GUARD_ASSIST_BRAKING,
    _a[exports.ROUTE_TABLE.SETTINGS.FLEET.NOTIFICATIONS.SAFETY_EVENTS.COLLISION_MITIGATION_BRAKING] = exports.GTM.PAGE_NAME.SETTINGS.FLEET.NOTIFICATIONS.SAFETY_EVENTS.COLLISION_MITIGATION_BRAKING,
    _a[exports.ROUTE_TABLE.SETTINGS.FLEET.NOTIFICATIONS.SAFETY_EVENTS.ENHANCED_STABILITY_CONTROL_EVENT] = exports.GTM.PAGE_NAME.SETTINGS.FLEET.NOTIFICATIONS.SAFETY_EVENTS.ENHANCED_STABILITY_CONTROL,
    _a[exports.ROUTE_TABLE.SETTINGS.FLEET.NOTIFICATIONS.SAFETY_EVENTS.FORWARD_COLLISION_WARNING] = exports.GTM.PAGE_NAME.SETTINGS.FLEET.NOTIFICATIONS.SAFETY_EVENTS.FORWARD_COLLISION_WARNING,
    _a[exports.ROUTE_TABLE.SETTINGS.FLEET.NOTIFICATIONS.SAFETY_EVENTS.HANDS_OFF_WHEEL] = exports.GTM.PAGE_NAME.SETTINGS.FLEET.NOTIFICATIONS.SAFETY_EVENTS.HANDS_OFF_WHEEL,
    _a[exports.ROUTE_TABLE.SETTINGS.FLEET.NOTIFICATIONS.SAFETY_EVENTS.INDEX] = exports.GTM.PAGE_NAME.SETTINGS.FLEET.NOTIFICATIONS.SAFETY_EVENTS.INDEX,
    _a[exports.ROUTE_TABLE.SETTINGS.FLEET.NOTIFICATIONS.SAFETY_EVENTS.ROLL_STABILITY_CONTROL_EVENT] = exports.GTM.PAGE_NAME.SETTINGS.FLEET.NOTIFICATIONS.SAFETY_EVENTS.ROLL_STABILITY_CONTROL,
    _a[exports.ROUTE_TABLE.SETTINGS.FLEET.NOTIFICATIONS.SAFETY_EVENTS.SEVERE_BRAKING] = exports.GTM.PAGE_NAME.SETTINGS.FLEET.NOTIFICATIONS.SAFETY_EVENTS.SEVERE_BRAKING,
    //  [ROUTE_TABLE.SETTINGS.FLEET.NOTIFICATIONS.SAFETY_SYSTEMS.LIST]: GTM.PAGE_NAME.SETTINGS.FLEET.NOTIFICATIONS.SAFETY_SYSTEMS.LIST,
    _a[exports.ROUTE_TABLE.SETTINGS.FLEET.NOTIFICATIONS.SAFETY_SYSTEMS.ABA] = exports.GTM.PAGE_NAME.SETTINGS.FLEET.NOTIFICATIONS.SAFETY_SYSTEMS.ABA,
    _a[exports.ROUTE_TABLE.SETTINGS.FLEET.NOTIFICATIONS.SETTINGS] = exports.GTM.PAGE_NAME.SETTINGS.FLEET.NOTIFICATIONS.SETTINGS,
    //  [ROUTE_TABLE.SETTINGS.FLEET.NOTIFICATIONS_INDIVIDUAL_FAULTS]: GTM.PAGE_NAME.SETTINGS.FLEET.NOTIFICATIONS_INDIVIDUAL_FAULTS,
    _a[exports.ROUTE_TABLE.SETTINGS.REGISTRATION] = exports.GTM.PAGE_NAME.SETTINGS.REGISTRATION,
    _a[exports.ROUTE_TABLE.SETTINGS.ROLE_CREATE] = exports.GTM.PAGE_NAME.SETTINGS.USERS.ROLE_CREATE,
    _a[exports.ROUTE_TABLE.SETTINGS.ROLE_EDIT] = exports.GTM.PAGE_NAME.SETTINGS.USERS.ROLE_EDIT,
    _a[exports.ROUTE_TABLE.SETTINGS.CUSTOM_TAGS] = exports.GTM.PAGE_NAME.SETTINGS.VEHICLES.CUSTOM_TAGS,
    _a[exports.ROUTE_TABLE.SETTINGS.MANAGE_VEHICLES.VEHICLE_CONTACTS] = exports.GTM.PAGE_NAME.SETTINGS.VEHICLES.VEHICLE_CONTACTS,
    _a[exports.ROUTE_TABLE.SETTINGS.MANAGE_VEHICLES.NEW_VEHICLE_CONTACT] = exports.GTM.PAGE_NAME.SETTINGS.VEHICLES.NEW_VEHICLE_CONTACT,
    _a[exports.ROUTE_TABLE.SETTINGS.MANAGE_VEHICLES.EDIT_VEHICLE_CONTACT] = exports.GTM.PAGE_NAME.SETTINGS.VEHICLES.EDIT_VEHICLE_CONTACT,
    _a)));
